/**
 * useIsReaderRole - Hook to determine if current user is primarily a Reader
 * 
 * PURPOSE: Gate Reader Credit Model (RCM) features to only Reader roles.
 * 
 * LOGIC: A user is considered a "Reader" for RCM purposes if:
 * - They have NO higher roles (Admin, Publisher, Author/Creator)
 * - OR they ONLY have the "reader" role
 * 
 * Non-Readers should NEVER see:
 * - Credit balances
 * - "Buy Credits" buttons
 * - Credit-related modals
 * - RCM-related API calls
 */
import { useAuth } from '../contexts/AuthContext';

export const useIsReaderRole = () => {
  const { user } = useAuth();
  const roles = user?.roles || [];
  
  // User is NOT a Reader for RCM purposes if they have any non-reader role
  const hasNonReaderRole = 
    roles.includes('admin') || 
    roles.includes('publisher') || 
    roles.includes('author') || 
    roles.includes('creator');
  
  // True = show RCM UI, False = hide RCM UI
  return !hasNonReaderRole;
};

export default useIsReaderRole;
